<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 处方大全管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-button type="primary" icon="el-icon-lx-add" class="handle-del mr10" @click="handleAdd()">新增处方大全</el-button>
            </div>
            <div class="handle-box">
                <el-input v-model="query.bookName" placeholder="处方名称" class="handle-input mr10" size="mini "></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="bookName" label="处方大全名称" align="center"></el-table-column>
                <el-table-column prop="sortNo" label="排序" align="center"></el-table-column>
                <el-table-column label="缩略图" align="center">
                    <template width="90" slot-scope="scope">
                        <img style="width:80px;height:80px;border:none;" :src="scope.row.imagePath">
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="handleView(scope.$index, scope.row)">查看</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog title="新增处方大全" :visible.sync="insertVisible" width="50%">
            <el-form ref="form" :model="medicineBookAdd" label-width="70px">
                <el-form-item label="名称">
                    <el-input v-model="medicineBookAdd.bookName" placeholder="处方大全名称" class="phone-input mr10"></el-input>
                </el-form-item>
                <el-form-item label="排序码">
                    <el-input v-model="medicineBookAdd.sortNo" placeholder="请输入排序码" class="phone-input mr10"></el-input>
                </el-form-item>
                <el-form-item label="图片">
                    <el-upload
                            class="avatar-uploader"
                            action="http://127.0.0.1:18082/1005/10015/100020"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">

                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="insertVisible = false">取 消</el-button>
                <el-button type="primary" @click="AddEdit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog title="修改处方大全" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="medicineBookUpdate" label-width="70px">
                <el-form-item label="名称">
                    <el-input v-model="medicineBookUpdate.bookName" class="handle-input mr10"></el-input>
                </el-form-item>
                <el-form-item label="排序码">
                    <el-input v-model="medicineBookUpdate.sortNo" class="handle-input mr10"></el-input>
                </el-form-item>
                <el-form-item label="图片">
                    <el-upload
                            class="avatar-uploader"
                            action="http://127.0.0.1:18082/1005/10015/100020"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">

                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" >

                <el-button @click="editVisible = false" >取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>

    export default {
        name: 'basetable',
        data() {
            return {
                imageURL:"",
                query: {
                    bookName: ''
                },
                imageUrl:'',
                tableData: {
                    medicineBook: {
                        pdx: '',
                        bookId: '',
                        bookName: '',
                        sortNo: '',
                        imagePath: '',
                        createDate: '',
                        updateDate: ''
                    }
                }
                ,
                form: {
                    patient: {
                        pdx: '',
                        bookId: '',
                        bookName: '',
                        sortNo: '',
                        imagePath: '',
                        createDate: '',
                        updateDate: ''
                    }
                },
                medicineBookAdd: {
                    bookName: '',
                    sortNo: '',
                    imagePath: '',
                },
                medicineBookUpdate: {
                    pdx: '',
                    bookId: '',
                    bookName: '',
                    sortNo: '',
                    imagePath: ''

                },
                editVisible: false,
                insertVisible: false,
            };
        },
        created() {

            this.getData();
        },
        methods: {

            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },

            beforeAvatarUpload(file) {
                // 文件类型进行判断
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error("上传图片只能是 JPG 格式!");
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 2MB!");
                }
                return isJPG && isLt2M;
            },

            getData() {
                this.axios.get('/1002/10012/100013', this.query).then((res) => {
                    if (res.data != null) {
                        var data =res.data;
                        this.tableData = data.data;
                    } else {
                        this.$message.success("暂无数据");
                    }
                })
            },
            // 触发搜索按钮
            handleSearch() {
                this.axios.get('/1002/10012/100012?bookName='+this.query.bookName).then((res) => {
                    if (res.data != null) {
                        var data =res.data;
                        this.tableData = data.data;
                    } else {
                        this.$message.success("暂无数据");
                    }
                })
            },
            // 删除处方大全
            handleDelete(index,row) {
                var params = new URLSearchParams();
                params.append("bookId",row.bookId);
                // 二次确认删除
                this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.axios.post("/1002/10012/100019",params).then((res) => {
                                if (res.data.code == 10000) {
                                    this.$message.success(res.data.message);
                                    this.tableData.splice(index, 1);
                                } else {
                                    this.$message.success(res.data.message);
                                }
                            }
                        )

                    })
                    .catch(() => {
                    });
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            insert() {
                this.medicineBookAdd.imagePath = this.imageUrl;
                this.axios.post('/1002/10012/100014', this.medicineBookAdd).then((res) => {
                    if (res.data.code == "10000") {
                        this.$message.success('新增成功');
                    } else {
                        this.$message.success('新增失败');
                    }
                    this.getData();
                })
            },
            update() {
                this.axios.post('/patient/updatePatient', this.patientUpdate).then((res) => {
                    if (res.data.message == "修改成功") {
                        this.$message.success('修改成功');
                    } else {
                        this.$message.success('修改失败');
                    }
                    this.getData();
                })
            },
            //查看处方大全
            handleView(index, row) {

            },
            // 编辑操作
            handleEdit(index, row) {
                this.editVisible = true;
                this.medicineBookUpdate = row;
            },
            handleAdd() {
                this.insertVisible = true;
            },
            // 保存编辑
            saveEdit() {
                this.editVisible = false;
                this.update();
            },
            // 新增
            AddEdit() {
                this.insertVisible = false;

                this.insert();
            },
            // 分页导航
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 100px;
        display: inline-block;
    }

    .phone-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #62ff00;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

</style>
